module.exports = __webpack_public_path__ + "img/placeholder.15fd1ca4.png";